export const REFRESH_DAILY_DEALS_UPDATE_TOKEN = 'REFRESH_DAILY_DEALS_UPDATE_TOKEN';
export const RESET_DAILY_DEALS_DATA = 'RESET_DAILY_DEALS_DATA';
export const FETCH_DAILY_DEALS = 'FETCH_DAILY_DEALS';
export const FETCH_DAILY_DEALS_ASSETS = 'FETCH_DAILY_DEALS_ASSETS';
